// Shared, non-component helpers for reel beat backgrounds (label maps + poster-src resolution).
// Kept out of the component modules so React Fast Refresh stays happy.

import type { BeatBackground, ImageSrc, VideoBeatRole } from '../types'

export const ROLE_LABEL: Record<VideoBeatRole, string> = {
  hook: 'Hook',
  value: 'Value',
  turn: 'Turn',
  cta: 'CTA',
}

export const BG_LABEL: Record<BeatBackground['kind'], string> = {
  video: 'Motion clip',
  photo: 'Brand photo',
  card: 'Brand card',
}

export function directSrcUrl(src: ImageSrc | null | undefined): string | undefined {
  if (!src) return undefined
  if (src.kind === 'url') return src.url
  if (src.kind === 'dataUri') return src.dataUri
  return undefined
}

/** The still used to preview a beat's background (photo → its photo; video → poster/first candidate). */
export function backgroundPosterSrc(bg: BeatBackground): ImageSrc | undefined {
  if (bg.kind === 'photo') return bg.photoSrc
  if (bg.kind === 'video') return bg.posterSrc ?? bg.candidates?.[0] ?? bg.clipSrc
  return undefined
}
